module.exports = __webpack_public_path__ + "img/add-s-6.a444b180.png";